import React from 'react';
import * as S from './styles';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { Mail } from 'styled-icons/feather';
import moment from 'moment';
import { ToolTip } from 'components/ToolTip';

interface ICard {
  name: string | undefined;
  status: 'baixo' | 'medio' | 'alto' | 'médio' | 'novo cliente';
  broker?: string;
  date?: string;
  value?: string;
}

const getStatus: any = {
  Pendete: 'aberta',
  Assinado: 'paga',
  cancelada: 'cancelada',
  expirada: 'venda',
  Rascunho: 'rascunho',
  Recusado: "cancelada",
  Invalidado: "cancelada",
  Expirado: "cancelada",
};
const CardDrawer = ({ name, status, date, broker, value }: ICard) => {
  return (
    <S.CardContent>
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
        <div>
          <S.TextCard fontSize="12" color="#808080">
            Criado em {moment(date).format('DD/MM [às] HH:mm')} por {broker}
          </S.TextCard>
          <S.TextAside fontSize="16" fontWeight="700">
            {name || `Não informado`}
          </S.TextAside>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '16px' }}>
        <InvoiceStatus
          status={getStatus[status]}
          text={status}
          fontWeight="500"
        />
        <span style={{ alignSelf: 'center' }}>
        <ToolTip
                  right="2rem"
                  height="3rem"
                  content={
                    Math.abs(Number(value || 0)) < 2
                      ? 'Assinatura padrão.'
                      : 'Assinatura com prova de vida utilizam um envelope a mais.'
                  }
                  icon={
                    <InvoiceStatus
                    status="venda"
                    text={Math.abs(Number(value || 0))}
                    icon={<Mail size={16} />}
                    fontWeight="500"
                  />
                  }
                />
     
        </span>
      </div>
    </S.CardContent>
  );
};

export default CardDrawer;
